(function(algolia, searchClientV5) {
  'use strict';

  if (
    !algolia ||
    !algolia.config ||
    !algolia.externals ||
    algolia.config.search_client_version !== 5
  ) {
    return;
  }

  if (!searchClientV5 || typeof searchClientV5.liteClient !== 'function') {
    throw new Error('Algolia search client v5 failed to load');
  }

  var externals = {};
  Object.keys(algolia.externals).forEach(function(name) {
    externals[name] = algolia.externals[name];
  });
  externals.algoliasearch = searchClientV5.liteClient;
  algolia.externals = externals;
})(window.algoliaShopify, window['algoliasearch/lite']);
